import * as React from 'react';

export const TheCataclysm = () => (<strong className="the-cataclysm">The Cataclysm</strong>);